var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Row, Col, Modal, ModalHeader } from "react-bootstrap";
import React, { Component } from "react";
import { isEmpty } from "lodash";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Card from "@irati/ui/src/Layout/Card";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import tracking from "@irati-tracking/perks/perks";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import { getDealByUrlSlug } from "@irati/deals/services/deals";
import GenericErrorCodes from "@irati/utils/services/errorCodes/Generic";
import MobileContinue from "./styled/MobileContinue";
import MobileInfoWrapper from "./styled/MobileInfoWrapper";
import MobileFlushCol from "./styled/MobileFlushCol";
import DealSEO from "../../components/DealSEO";
import DealImportantInfoContainer from "../DealImportantInfoContainer";
import DealInfoBlock from "../../components/DealInfoBlock";
import LayoutDealsInfo from "../../components/LayoutDealsInfo/LayoutDealsInfo";
import RequireDealStatusOn from "../../components/RequireDealStatusOn";
import { StyledDiv, StyledCard } from "./styled/DealInfo";
var DealInfo = /** @class */ (function (_super) {
    __extends(DealInfo, _super);
    function DealInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            deal: {},
            load: hangPromise(),
            showInfoPopUp: false
        };
        _this.componentDidMount = function () {
            _this.setState({
                load: _this.get()
            });
        };
        _this.get = function (urlSlug) {
            if (urlSlug === void 0) { urlSlug = _this.getUrlSlug(_this.props); }
            var config = { sentryIgnoreError: [GenericErrorCodes.PBERRForbidden] };
            return getDealByUrlSlug(urlSlug, config).then(function (deal) {
                tracking.viewPerk(deal);
                _this.setState({ deal: deal, load: null });
            });
        };
        _this.handlePopUp = function () {
            _this.setState({
                showInfoPopUp: !_this.state.showInfoPopUp
            });
        };
        return _this;
    }
    DealInfo.prototype.getUrlSlug = function (props) {
        return props.match.params.urlSlug;
    };
    DealInfo.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var newUrlSlug = this.getUrlSlug(newProps);
        var urlSlug = this.getUrlSlug(this.props);
        if (newUrlSlug !== urlSlug) {
            this.get(newUrlSlug);
        }
    };
    DealInfo.prototype.render = function () {
        var _a = this.state, load = _a.load, deal = _a.deal;
        var user = authentication.user();
        var showContinueButton = !isAppOnly(deal) && !isUserDOBRequired(deal) && !isEmpty(deal) &&
            !isPerksGO(deal) && !isDealUnavailable(deal);
        var idNamespace = id("deal-info", this.props, { force: true });
        return (React.createElement(Loading, { load: load, Error: RequireDealStatusOn },
            React.createElement(RequireDealStatusOn, { deal: deal },
                React.createElement(DealSEO, { deal: deal }),
                React.createElement(LayoutDealsInfo, { deal: deal }),
                React.createElement(StyledDiv, null,
                    React.createElement(Row, null,
                        React.createElement(MobileFlushCol, { md: 8, sm: 12 },
                            React.createElement(StyledCard, { large: true },
                                React.createElement(DealInfoBlock, { deal: deal, user: user, id: idNamespace }))),
                        React.createElement(Col, { md: 4, smHidden: true, xsHidden: true },
                            React.createElement(Card, null,
                                React.createElement(DealImportantInfoContainer, { user: user, deal: deal }))),
                        showContinueButton &&
                            React.createElement(Col, { lgHidden: true, mdHidden: true, sm: 12 },
                                React.createElement(MobileContinue, { primary: true, large: true, onClick: this.handlePopUp },
                                    React.createElement(FormattedMessage, { id: "perks.containers.dealInfo.continue" }))))),
                React.createElement(Modal, { show: this.state.showInfoPopUp, onHide: this.handlePopUp, className: "modal-slide-up modal-full-screen", contentLabel: this.props.formatMessage({ id: "perks.containers.dealInfo.contentLabel" }) },
                    React.createElement(ModalHeader, { closeButton: true }),
                    React.createElement(MobileInfoWrapper, null,
                        React.createElement(DealImportantInfoContainer, { user: user, deal: deal }))))));
    };
    return DealInfo;
}(Component));
export default injectIntl(DealInfo);
